export const MINUTES_TIMEOUT_REQUESTS = 1

export const DECIMAL_LENGTH_QUOTAS_FIELD = 5
